import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

interface AppLink {
  label: string;
  link: string;
  right?: string;
  icon: string;
}

@Injectable({
  providedIn: 'root',
})
export class UtilityAppsService {
  appsList = signal<AppLink[]>([]);
  appsList$ = toObservable<AppLink[]>(this.appsList);
}
